import { Box, Typography } from '@mui/material'
import { ReactElement } from 'react'
import { useAppSelector } from '../../../redux/hook'
import {
    Applications,
    IN_TRANSIT_TABS,
    UserPermissions,
    RoutePaths,
    USER_ROLES,
} from '../../../constants/constants'
import { Navigate } from 'react-router-dom'
import Empty from '../SideNav/Empty'

const Home = (): ReactElement => {
    const isLoadingTemplates = useAppSelector(
        (state) => state.nav.isLoadingTemplates,
    )
    const orgSlice = useAppSelector((state) => state.org)
    const {
        permissions = [],
        enabledApplications = [],
        org,
        loadingPermissions,
    } = orgSlice
    const userRole = useAppSelector((state) => state.user.user?.role) ?? ''

    if (loadingPermissions || isLoadingTemplates) {
        return <Empty />
    }
    if (!org) {
        return <Empty />
    }
    if (enabledApplications.includes(Applications.inTransit.id)) {
        return <Navigate to={RoutePaths.ccl} />
    } else if (
        enabledApplications.includes(Applications.facilityMonitoring.id)
    ) {
        return <Navigate to={RoutePaths.facilityMonitoring} />
    } else if (enabledApplications.includes(Applications.analytics.id)) {
        return <Navigate to={RoutePaths.analytics} />
    } else if (
        enabledApplications.includes(Applications.deviceManager.id) ||
        userRole === USER_ROLES.DEVICE_MANAGER ||
        userRole === USER_ROLES.SYSTEM_READER ||
        permissions.includes(UserPermissions.ORG_ADMIN)
    ) {
        return <Navigate to={RoutePaths.deviceManager} />
    } else if (
        permissions.includes(UserPermissions.USER_ADMIN) ||
        permissions.includes(UserPermissions.SYSTEM_READER)
    ) {
        if (org.name === 'Root') {
            return <Navigate to={RoutePaths.networkAdmin} />
        } else {
            return (
                <Navigate
                    to={`${RoutePaths.ccl}?tabIndex=${IN_TRANSIT_TABS.SETTINGS}`}
                />
            )
        }
    }

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100%',
                width: '100%',
            }}
        >
            <Typography
                variant="h6"
                component="div"
                sx={{ flexGrow: 1, textAlign: 'center' }}
            >
                Welcome to UBQ
            </Typography>
        </Box>
    )
}

export default Home
